// libs
import { concat } from 'lodash';

// services
import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

// stores
import { PaymentsStore } from "@distributor/svelte/Stores/PaymentsStore";

// types
import type { PaymentTransferType } from "@shared/types/Invoice";

// constants
const baseUrl = '/api/distributor/payments';

// functions
const extractPagination = (response, pageNum) => {
  let perPage, totalEntries;
  for (const pair of response.headers.entries()) {
    const key = pair[0];
    switch (key) {
      case "x-pagination-limit":
        perPage = parseInt(pair[1]);
        break;
      case "x-pagination-entries":
        totalEntries = parseInt(pair[1]);
        break;
    }
  };

  return {
    page: Number(pageNum || 1),
    perPage: perPage,
    totalEntries: totalEntries,
  };
};

export const setLoadedState = (loadedStatus) => {
  PaymentsStore.update(state => ({
    ...state,
    loaded: loadedStatus,
    failed: false
  }));
};

export const resetPayments = () => {
  PaymentsStore.update(state => ({
    ...state,
    invoices: [],
  }))
};

// requests
// --------
// get transfers index
export const index = async (transfers: PaymentTransferType[], filters: any, pageNum?: number) => {
  setLoadedState(false);

  // request payload
  const urlParams = new URLSearchParams({
    page: (pageNum || 1).toString(),
    ...(filters.searchValue && {search: filters.searchValue}),
    ...(filters.status && {status: filters.status}),
    ...(filters.startDate && {start_date: filters.startDate}),
    ...(filters.endDate && {end_date: filters.endDate}),
  });
  const requestData = {
    method: 'GET',
    url: baseUrl + '?' + urlParams
  };

  // request
  const response = await HttpPromiseWithEntireResponse(requestData);

  // callbacks
  if (response.ok) {
    const json = await response.json();
    const pagination = extractPagination(response, pageNum);
    let newTransfers = transfers;
    if (json.length && (transfers.length <= pagination.totalEntries)) {
      newTransfers = concat(transfers, json);
    }
    PaymentsStore.update(state => ({
      ...state,
      transfers: newTransfers,
      loaded: true,
      failed: false,
      pagination: pagination,
    }))
  } else {
    PaymentsStore.update(state => ({
      ...state,
      loaded: true,
      failed: true,
    }));
  };
};
